// Tracking libraries
import { ampli } from "ampli";
import { AnalyticsBrowser } from "@segment/analytics-next";

// Redux
import { setAmpliLoaded } from "store/slices/applicationSlice";
import store from "store";

export function initAmpli() {
  ampli.load({
    disabled: window.location.hostname === "localhost",
    environment: process.env.REACT_APP_AMPLITUDE_ENV,
  });

  ampli.addEventMiddleware(({ event }) => {
    const { event_type, event_properties } = event;

    // Create Segment tracker
    const segment = AnalyticsBrowser.load({ writeKey: process.env.REACT_APP_SEGMENT_WRITE_KEY });
    segment.track(event_type, { ...event_properties, source_website: "digital_identity" });
  });

  store.dispatch(setAmpliLoaded(true));
}
